// extracted by mini-css-extract-plugin
export default {"homePage":"HomePage_homePage__GDK2b","title":"HomePage_title__UFLA3","fadeInUp":"HomePage_fadeInUp__V+YEU","button":"HomePage_button__C9l6N"};